interface IProps {
    size?: number;
}

export const IconPoint = (props: IProps) => {
    const { size } = props;
    const defaultSize = "20";
    return (
        <svg
            width={size || defaultSize}
            height={size || defaultSize}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="8"
                cy="8"
                r="7.5"
                fill="url(#paint0_radial_6389_46180)"
                stroke="url(#paint1_linear_6389_46180)"
            />
            <path
                d="M5.5 12.5V4H8.85352C9.49821 4 10.0474 4.12313 10.5012 4.36938C10.955 4.61287 11.3009 4.95182 11.5388 5.38623C11.7795 5.81787 11.8999 6.31592 11.8999 6.88037C11.8999 7.44482 11.7782 7.94287 11.5347 8.37451C11.2912 8.80615 10.9384 9.14233 10.4763 9.38306C10.017 9.62378 9.46086 9.74414 8.80786 9.74414H6.67041V8.30395H8.51733C8.8632 8.30395 9.14819 8.24447 9.37231 8.12549C9.5992 8.00374 9.76798 7.83634 9.87866 7.62329C9.99211 7.40747 10.0488 7.15983 10.0488 6.88037C10.0488 6.59814 9.99211 6.35189 9.87866 6.1416C9.76798 5.92855 9.5992 5.76392 9.37231 5.64771C9.14543 5.52873 8.85767 5.46924 8.50903 5.46924H7.29712V12.5H5.5Z"
                fill="url(#paint2_linear_6389_46180)"
            />
            <defs>
                <radialGradient
                    id="paint0_radial_6389_46180"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(7.93043 7.16522) rotate(89.5489) scale(8.83506 9.79058)"
                >
                    <stop stop-color="#F2CA3C" />
                    <stop offset="1" stop-color="#F2AA3C" />
                </radialGradient>
                <linearGradient
                    id="paint1_linear_6389_46180"
                    x1="12.2435"
                    y1="15.6522"
                    x2="2.22609"
                    y2="2.64348"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#C89137" />
                    <stop offset="1" stop-color="#FFF500" stop-opacity="0.2" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_6389_46180"
                    x1="8.69995"
                    y1="4"
                    x2="8.69995"
                    y2="12.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FEF7E6" />
                    <stop offset="1" stop-color="#FFFFFD" />
                </linearGradient>
            </defs>
        </svg>
    );
};
